import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  class: "text-truncate",
  style: {"max-width":"200px"}
}
const _hoisted_3 = { class: "table table-hover m-0" }
const _hoisted_4 = { class: "cursor-pointer" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "flex-fill text-truncate" }

import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {__} from "~/ts/library/Translate";
import ElCardSectionWithTable from "~/cabinet/vue/interface/card/ElCardSectionWithTable.vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import Delay from "~/ts/library/Delay";
import AttachmentsConfig from "~/cabinet/vue/interface/AttachmentsConfig.vue";
import OperatorApplicationUploadHelper from "~/operatorApplication/ts/request/OperatorApplicationUploadHelper";
import {computed, onMounted, ref, watch} from "vue";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {InputInstance} from "element-plus";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {
    createEmptyMessageTemplateModel
} from "~/operatorApplication/vue/dialogs/dialog/textarea/buttons/MessageTemplateButtonInterface";



import Draggable from "~/node_modules/vuedraggable/src/vuedraggable.js";

const __default__ = {
    name: "OperatorApplicationSelectTemplateDialog",
    components: {
        Draggable
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    visible: { type: Boolean },
    client: {},
    addTemplateModel: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

const WITHOUT_CATEGORY = "withoutCategory";

let props = __props

let emits = __emit;

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

let searchInput = ref<InputInstance>();
let categoryId = ref<string>();
let search = ref<string>();
let editDialog = ref<{
    model: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel,
    visible: boolean
}>();

let templateGroups = ref<{
    descr: string,
    templates: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel[],
    showAddButton?: boolean,
    orderAllowed: boolean
}[]>();


let categories = computed(() => {
    let withoutCategory: OperatorApplicationApi.OperatorGetParamsMessageTemplateCategoryOpenApiModel = {
        id: WITHOUT_CATEGORY,
        siteId: null,
        descr: __("Вне категорий")
    };
    let result = templatesData.value ? [...templatesData.value.categories, withoutCategory] : [withoutCategory];

    if (search.value) {
        result = result.filter(category => {
            return !!templatesData.value.templates.find(template => checkCategoryId(template, category.id));
        });
    }

    if (!result.find(category => category.id == categoryId.value)) {
        categoryId.value = result.length ? result[0].id : null;
    }
    return result;
});

let categoriesForForm = computed(() => {
    return templatesData.value ? [...templatesData.value.categories] : [];
});

let site = computed(() => {
    return OperatorAccountStore.sitesDictionary.value[props.client.siteId];
});

let templatesData = computed(() => {
    if (site.value) {
        let result = OperatorAccountStore.getMessageTemplatesBySite(site.value.id);
        if (search.value) {
            result = {...result};
            let searchLowerCase = search.value.toLowerCase();
            let idsList: string[] = [];
            let templatesForSearch = OperatorAccountStore.templatesForSearch.value[site.value.id];
            for (let item of templatesForSearch) {
                if (item.search.indexOf(searchLowerCase) > -1) {
                    idsList.push(item.template.id);
                }
            }
            result.templates = result.templates.filter(template => idsList.includes(template.id));
        }
        return result;
    }
    return null;
});

onMounted(() => {
    setTimeout(() => {
        searchInput.value?.focus();
    }, 100);
    if (props.addTemplateModel) {
        editTemplate(props.addTemplateModel);
    }
});

function checkCategoryId(template: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel, categoryId: string) {
    return (template.categoryIds && template.categoryIds.includes(categoryId)) || (!template.categoryIds && categoryId == WITHOUT_CATEGORY);
}

let templates = computed(() => {
    let result: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel[] = [];
    if (templatesData.value) {
        for (let template of templatesData.value.templates) {
            if (checkCategoryId(template, categoryId.value)) {
                result.push(template);
            }
        }
    }
    return result;
});

watch(templates, () => setTemplatesData(), {deep: true});

function setTemplatesData() {
    templateGroups.value = [];
    if (canUsePrivateTemplates.value) {
        templateGroups.value.push({
            descr: __("Личные шаблоны"),
            templates: templates.value.filter(template => !template.isShared),
            showAddButton: true,
            orderAllowed: true
        });
    }
    templateGroups.value.push({
        descr: __("Общие шаблоны"),
        templates: templates.value.filter(template => template.isShared),
        orderAllowed: canEditSharedTemplates.value
    });
}


let canEditSharedTemplates = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canEditSharedTemplates;
});

let canUsePrivateTemplates = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canUsePrivateTemplates;
});

let canViewOperatorsLogin = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin;
});

let operators = computed(() => {
    if (site.value) {
        return OperatorAccountStore.data.value.operators.filter(operator => site.value.operators.indexOf(operator.login) > -1);
    } else {
        return [];
    }
});

let operatorGroups = computed(() => {
    return site.value?.groups ?? [];
});

function editTemplate(template?: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel) {
    if (!template) {
        template = createEmptyMessageTemplateModel();
        template.categoryId = categoryId.value == WITHOUT_CATEGORY ? null : categoryId.value;
    }
    editDialog.value = {
        visible: true,
        model: template
    }
}


async function deleteTemplate(template: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel) {
    try {
        await ElConfirm(__("Вы уверены, что хотите удалить этот шаблон?"));
        let p: OperatorApplicationApi.OperatorMessageTemplateDeleteOpenApiModel = {
            id: template.id
        };
        await (new OperatorApiRequest({
            url: "/messageTemplate/deleteMessageTemplate",
            p
        })).save();
    } catch (e) {

    }
}

let isReadyToSave = computed(() => {
    let model = editDialog.value.model;
    return model && (model.attachments && model.attachments.length) || typeof model.text == "string";
});

async function saveTemplate() {
    let model = editDialog.value.model;
    if (isReadyToSave.value) {
        let attachments = model.attachments
            .filter(attachment => !!attachment.url)
            .map(attachment => {
                if (!attachment.size) {
                    delete attachment.size;
                }
                return attachment;
            })

        let p: OperatorApplicationApi.OperatorMessageTemplateSaveOpenApiModel = {
            id: model.id ? model.id : undefined,
            descr: model.descr,
            text: typeof model.text == "string" ? model.text : undefined,
            //categoryId: model.categoryId ? model.categoryId : undefined,
            categoryIds: model.categoryIds ? model.categoryIds : undefined,
            operators: model.operators ? model.operators : undefined,
            operatorGroups: model.operatorGroups ? model.operatorGroups : undefined,
            siteId: props.client.siteId,
            attachments: attachments
        };
        let result = await (new OperatorApiRequest({
            url: "/messageTemplate/saveMessageTemplate",
            p
        })).save();
        if (result.isSuccess) {
            editDialog.value = null;
            onUpdateEditDialogVisible();
        }
    }
}

async function onOrderChange(templates: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel[]) {
    try {
        Delay.make(1000, "templateOrderChange", true);
        let p: OperatorApplicationApi.OperatorMessageTemplateChangeOrderOpenApiModel = {
            templateIds: templates.map(template => template.id)
        };
        let result = await (new OperatorApiRequest({
            url: "/messageTemplate/changeMessageTemplateOrder",
            p,
            silent: true
        })).send();
        result.showMessageOnError();
    } catch (e) {
    }
}

function onUpdateEditDialogVisible() {
    if (props.addTemplateModel) {
        isVisible.value = false;
    }
}

function t(template: any): OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel {
    return template;
}

let uploadHelper = computed(() => {
    return new OperatorApplicationUploadHelper();
});

setTemplatesData();

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(categories) && !__props.addTemplateModel)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          title: _unref(__)('Выберите быстрый ответ'),
          "close-on-press-escape": "",
          modelValue: _unref(isVisible),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
          width: "700px",
          class: "template-select-dialog"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_input, {
                modelValue: _unref(search),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event)),
                ref_key: "searchInput",
                ref: searchInput,
                placeholder: _unref(__)('Поиск')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode(_component_el_tabs, {
              "tab-position": "left",
              modelValue: _unref(categoryId),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(categoryId) ? (categoryId).value = $event : categoryId = $event)),
              class: "el-tabs-no-content-padding"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (category) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: category.id,
                    label: category.descr,
                    name: category.id
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(category.descr), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateGroups), (group) => {
                        return (_openBlock(), _createBlock(_component_el_card, {
                          class: "no-shadow mb-4",
                          key: group.descr
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ElCardHeader, {
                              title: group.descr,
                              "button-col-span": group.showAddButton ? 10 : 0
                            }, {
                              default: _withCtx(() => [
                                (_unref(canUsePrivateTemplates))
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (editTemplate(null))),
                                      type: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(__)("Добавить шаблон")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["title", "button-col-span"]),
                            (!group.templates.length)
                              ? (_openBlock(), _createBlock(ElCardSection, {
                                  key: 0,
                                  class: "text-placeholder"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(__)("Шаблоны не созданы")), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(ElCardSectionWithTable, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("table", _hoisted_3, [
                                      _createVNode(_unref(Draggable), {
                                        tag: "tbody",
                                        modelValue: group.templates,
                                        "onUpdate:modelValue": ($event: any) => ((group.templates) = $event),
                                        disabled: !group.orderAllowed,
                                        "item-key": "id",
                                        onSort: ($event: any) => (onOrderChange(group.templates))
                                      }, {
                                        item: _withCtx(({element}) => [
                                          _createElementVNode("tr", _hoisted_4, [
                                            _createElementVNode("td", {
                                              onClick: ($event: any) => (_unref(emits)('select', t(element)))
                                            }, [
                                              _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("div", _hoisted_7, _toDisplayString(t(element).descr), 1),
                                                (t(element).isEditable || t(element).isRemovable)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 0,
                                                      class: "actions",
                                                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                                    }, [
                                                      (t(element).isEditable)
                                                        ? (_openBlock(), _createBlock(MyIconButton, {
                                                            key: 0,
                                                            edit: "",
                                                            onClick: ($event: any) => (editTemplate(t(element)))
                                                          }, null, 8, ["onClick"]))
                                                        : _createCommentVNode("", true),
                                                      (t(element).isRemovable)
                                                        ? (_openBlock(), _createBlock(MyIconButton, {
                                                            key: 1,
                                                            delete: "",
                                                            onClick: ($event: any) => (deleteTemplate(t(element)))
                                                          }, null, 8, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ], 8, _hoisted_5)
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onSort"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["label", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["title", "modelValue"]))
      : _createCommentVNode("", true),
    (_unref(editDialog) && _unref(editDialog).visible)
      ? (_openBlock(), _createBlock(MyDialog, {
          key: 1,
          visible: _unref(editDialog).visible,
          "onUpdate:visible": [
            _cache[11] || (_cache[11] = ($event: any) => ((_unref(editDialog).visible) = $event)),
            onUpdateEditDialogVisible
          ],
          form: { model: _unref(editDialog).model, labelPosition: 'top' },
          onApply: saveTemplate,
          "apply-disabled": !_unref(isReadyToSave)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(__)('Введите название шаблона:')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(editDialog).model.descr,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(editDialog).model.descr) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(__)('Введите текст сообщения:')
            }, {
              default: _withCtx(() => [
                _createVNode(TextInputWithVariables, {
                  modelValue: _unref(editDialog).model.text,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(editDialog).model.text) = $event)),
                  "max-height": 300,
                  bbcode: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_card, { class: "transparent-dashed-card mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(AttachmentsConfig, {
                      modelValue: _unref(editDialog).model.attachments,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(editDialog).model.attachments) = $event)),
                      "upload-helper": _unref(uploadHelper)
                    }, null, 8, ["modelValue", "upload-helper"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(__)('Категория шаблона:')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(editDialog).model.categoryIds,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(editDialog).model.categoryIds) = $event)),
                  class: "w-100",
                  clearable: "",
                  multiple: "",
                  placeholder: _unref(__)('Вне категорий')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoriesForForm), (category) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: category.id,
                        value: category.id,
                        label: category.descr
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(canEditSharedTemplates))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_form_item, {
                    label: _unref(__)('Пользователи шаблона:')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        multiple: "",
                        modelValue: _unref(editDialog).model.operators,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(editDialog).model.operators) = $event)),
                        class: "w-100",
                        placeholder: _unref(editDialog).model.operators.length ? '' : (_unref(editDialog).model.operatorGroups.length ? _unref(__)('Шаблон доступен только выбранными отделам') : _unref(__)('Если не выбрать - шаблон будет доступен всем'))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: operator.id,
                              label: `${operator.fio}${_unref(canViewOperatorsLogin) ? ` (${operator.login})` : ''}`,
                              value: operator.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _unref(__)('Отделы пользователей шаблона:')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        multiple: "",
                        modelValue: _unref(editDialog).model.operatorGroups,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(editDialog).model.operatorGroups) = $event)),
                        class: "w-100",
                        placeholder: _unref(editDialog).model.operatorGroups.length ? '' : (_unref(editDialog).model.operators.length ? _unref(__)('Шаблон доступен только выбранными операторам') : _unref(__)('Если не выбрать - шаблон будет доступен всем'))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operatorGroups), (group) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: group.id,
                              label: group.descr,
                              value: group.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible", "form", "apply-disabled"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})